import { inject, injectable } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import withCache from '@framework/with-cache';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';

@injectable()
class IndustryRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher) {}

  @withCache
  async getList () {
    const request = new Request('finsight_web.market.get_industries', {});
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }
}

export default IndustryRepository;
